import { List as AntList, Avatar, Tag } from 'antd';
import { useTheme } from 'contexts/theme';
import { PRIMARY, SECONDARY } from 'utils/colors';
import styles from './list.module.sass';
import { EnvironmentOutlined } from '@ant-design/icons';
import { Space } from 'antd';
interface ListDataProps {
  data: {
    title: string;
    manufactures?: number;
    distributors?: number;
    population?: number;
  }[];
}

export default function StateList({ data }: ListDataProps) {
  const { dark } = useTheme();
  return (
    <AntList
      itemLayout="horizontal"
      dataSource={data}
      className={dark ? styles['list-dark'] : styles.list}
      renderItem={(item) => (
        <AntList.Item>
          <AntList.Item.Meta
            avatar={<Avatar shape="square" icon={<EnvironmentOutlined />} />}
            title={item.title}
            description={
              <div>
                <div
                  style={{ marginBottom: 10 }}
                >{`Population ${item.population}`}</div>
                <Space>
                  {item.manufactures && (
                    <Tag
                      style={{ width: '100%' }}
                      color={PRIMARY}
                    >{`${item.manufactures} Manufactures`}</Tag>
                  )}
                  {item.distributors && (
                    <Tag
                      style={{ width: '100%' }}
                      color={SECONDARY}
                    >{`${item.distributors} Distributors`}</Tag>
                  )}
                </Space>
              </div>
            }
          />
        </AntList.Item>
      )}
    />
  );
}
